<template>
  <CardModule title="Dados Cadastrais">
    <template>
      <v-row>
        <v-col cols="12">
          <BaseTextField
            placeholder="Insira o nome da loja"
            label="Nome da loja"
            required
            v-model="$marketplace.cadastro.nome_loja"
            counter="150"
            :rules="RulesNomeLoja"
          >
          </BaseTextField>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <BaseTextField
            placeholder="Insira o CEP"
            label="CEP"
            required
            v-model="$marketplace.cadastro.cep"
            v-mask="'#####-###'"
            :error-messages="$marketplace.cadastro.error.cep"
            @input="$marketplace.cadastro.error.cep = []"
            hide-details
          >
          </BaseTextField>
        </v-col>
        <v-col cols="4">
          <BaseAutocomplete
            :items="$config.paises.result"
            placeholder="Selecione o país"
            label="País"
            required
            hide-details
            v-model="$marketplace.cadastro.pais"
            :loading="$config.loading_paises"
            item-text="dsc_lang"
            item-value="iso_full"
            needSelection
            :filter="search"
            :error-messages="$marketplace.cadastro.error.pais"
            @input="$marketplace.cadastro.error.pais = []"
          >
            <template v-slot:selection="{ item }">
              <template v-if="item ? (paises = item) : null">
                {{ item.dsc_lang }}
              </template>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content v-if="item">
                <v-list-item-title v-text="item.dsc_lang"></v-list-item-title>
              </v-list-item-content>
            </template>
          </BaseAutocomplete>
        </v-col>
        <v-col cols="4">
          <BaseAutocomplete
            :items="$config.estados.result"
            placeholder="Selecione o estado"
            label="Estado"
            required
            hide-details
            needSelection
            v-model="$marketplace.cadastro.estado"
            :loading="$config.loading_estados"
            item-text="dsc_lang"
            item-value="iso_full"
            :filter="search"
            :error-messages="$marketplace.cadastro.error.estado"
            @input="$marketplace.cadastro.error.estado = []"
          >
            <template v-slot:selection="{ item }">
              <template v-if="item ? (estados = item) : null">
                {{ item.dsc_lang }}
              </template>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content v-if="item">
                <v-list-item-title v-text="item.dsc_lang"></v-list-item-title>
              </v-list-item-content>
            </template>
          </BaseAutocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <BaseAutocomplete
            label="Cidade"
            required
            hide-details
            :items="$config.cidades.result"
            v-model="$marketplace.cadastro.cidade"
            :loading="$config.loading_cidades"
            item-text="dsc_lang"
            item-value="iso_full"
            placeholder="Selecione a cidade"
            :filter="search"
            :error-messages="$marketplace.cadastro.error.cidade"
            @input="$marketplace.cadastro.error.cidade = []"
          >
          </BaseAutocomplete>
        </v-col>
        <v-col cols="4">
          <BaseTextField
            label="Bairro"
            required
            hide-details
            placeholder="Insira o bairro"
            v-model="$marketplace.cadastro.bairro"
            type="text"
            :error-messages="$marketplace.cadastro.error.bairro"
            @input="$marketplace.cadastro.error.bairro = []"
          >
          </BaseTextField>
        </v-col>
        <v-col cols="4">
          <BaseTextField
            label="Endereço"
            required
            hide-details
            placeholder="Insira o endereço"
            v-model="$marketplace.cadastro.logradouro"
            type="text"
            :error-messages="$marketplace.cadastro.error.logradouro"
            @input="$marketplace.cadastro.error.logradouro = []"
          >
          </BaseTextField>
        </v-col>
      </v-row>
    </template>
  </CardModule>
</template>

<script>
import BaseTextField from "@/components/forms/BaseTextField.vue";
import CardModule from "@/components/cards/CardModule.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import configMarketplaceMixins from "@/mixins/configMarketplace.mixins.js";

export default {
  name: "RegistrationData",
  mixins: [configMarketplaceMixins],
  components: {
    BaseTextField,
    CardModule,
    BaseAutocomplete,
  },
  data() {
    return {
      paises: [],
      estados: [],
      cidades: [],
      RulesRazao: [
        v =>
          v.length <= 50 ||
          "A razão social não pode ter mais de 50 caracteres!",
      ],
      RulesNomeLoja: [
        v =>
          v.length <= 150 ||
          "O nome da loja não pode ter mais de 150 caracteres!",
      ],
    };
  },
  methods: {
    replaceSpecialChars(str) {
      str = str.toLowerCase();
      str = str.replace(/[ÀÁÂÃÄÅ]/, "a");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "e");
      str = str.replace(/[èèêë]/, "e");
      str = str.replace(/[Ç]/, "c");
      str = str.replace(/[ç]/, "c");
      str = str
        .toString()
        .normalize("NFD")
        .replace(/[^a-zA-Zs]/g, "");
      str = str.replace(" ", "-");

      return str;
      // return str.replace(/[^a-z0-9]/gi,'-');
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.dsc_lang.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
  },

  watch: {
    paises(e) {
      this.$config.getEstados(e.id);
    },
    estados(e) {
      this.$config.getCidades(e.id);
    },
    "$marketplace.cadastro.cep"(e) {
      if (e.length === 9) {
        this.$axios
          .get(`https://viacep.com.br/ws/${e}/json/`)
          .then(res => {
            if (res.erro) {
              throw new Error();
            }
            this.$marketplace.cadastro.pais = "Brasil";
            this.$marketplace.cadastro.estado = res.uf
              ? res.uf
              : this.$marketplace.cadastro.estado;
            this.$marketplace.cadastro.cidade = res.localidade
              ? res.localidade
              : this.$marketplace.cadastro.cidade;
            this.$marketplace.cadastro.bairro = res.bairro
              ? res.bairro
              : this.$marketplace.cadastro.bairro;
            this.$marketplace.cadastro.logradouro = res.logradouro
              ? res.logradouro
              : this.$marketplace.cadastro.logradouro;
          })
          .catch(error => {
            console.error(error);
          });
      }
    },
  },
  mounted() {
    this.$config.getPaises();
  },
};
</script>
